import { createTheme } from "@mui/material/styles";
import { hover } from "@testing-library/user-event/dist/hover";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#121923",
      dark: "#121923",
    },
    secondary: {
      main: "#027A48",
    },
    error: {
      main: "#ef5350",
    },
  },
  shape: {
    borderRadius: 30,
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: "white",
          fontFamily: "inherit",
          fontSize: "14px",
          fontStyle: "medium",
          fontWeight: 500,
          height: "60px",
          letterSpacing: "0.2px",
          boxShadow: "none",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
            background: "#36383aff",
          },
        },

        text: {
          color: "rgba(18, 183, 106, 1)",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            fontFamily: "inherit",
            paddingTop: "18px",
            // paddingLeft: "20px",
            "&:-webkit-autofill": {
              WebkitBoxShadow: "0 0 0 100px white inset",
              WebkitTextFillColor: "var(--Black-Black-500, #6B7280)",
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: "inherit",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E5E7EB !important", // Border color on hover
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px", // Border width on focus
            borderColor: "#E5E7EB !important", // Border color on focus
          },
        },
        notchedOutline: {
          borderWidth: "1px", // Default border width
        },
      },
    },

    MuiButtonBase: {
      styleOverrides: {
        root: {},
      },
    },
  },

  // breakpoints: {
  //   values: {
  //     xs: 0,       // Extra small screens (0px and up)
  //     sm: 640,     // Small screens (640px and up)
  //     md: 1024,    // Medium screens (1024px and up)
  //     lg: 1280,    // Large screens (1280px and up)
  //     xl: 1920,
  //   },
  // },
});
